import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { candidatureRequestHorsParcours } from 'src/app/model/candidatureRequestHorsParcours.model';
import { BehaviorSubject, map, Observable, tap, timeout } from 'rxjs';
import { Countries } from 'src/app/model/countries';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { ProfilDetailsHorsParcours } from 'src/app/model/profilDetailsHorsParcours';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import {
  ImageBlock,
  imageBlocks,
} from 'src/app/modules/shared/interfaces/ImageBlock';

@Component({
  selector: 'app-form-appel-hors-parcours',
  templateUrl: './form-appel-hors-parcours.component.html',
  styleUrls: ['./form-appel-hors-parcours.component.css'],
})
export class FormAppelHorsParcoursComponent implements OnInit {
  soumissionForm!: FormGroup;
  appelCloseDate!: string;
  appelName!: string;
  certificatName!: string;
  certificatDynamicOption: { id: number; name: string }[] = [];

  showEmailErrors$ = new BehaviorSubject<boolean>(false);
  countries!: Countries[];
  diplomes!: any;
  regions!: any;
  zones!: any;

  cohorte!: string;
  showPopup: boolean = false;
  paramValue?: string;
  paramValueDER_TABA?: string;
  paramsIncorrecte?: string = 'invalid';
  invalid: boolean = false;

  showDegreeDiv = false;
  showHandicapChoiceRadio = false;
  chooseAHandicapMoteur = false;
  chooseAHandicapAuditif = false;
  chooseAHandicapVisuel = false;
  chooseAHandicapAutre = false;
  imageBlocks: ImageBlock[] = imageBlocks;
  statutOptions: string[] = [
    'Diplômé/Sans emploi',
    'Etudiant',
    'Employé (CDD, CDI)',
    'Entrepreneur ou freelance',
    'Chercher un emploi',
  ];

  handicapOptions: string[] = [
    'Handicap visuel',
    'Handicap moteur',
    'Handicap auditif',
    'Autre handicap',
    'Non concerné',
  ];

  showWhatsAppNumberFields: boolean = false;
  phoneCodeWhatsapp!: any[];
  phoneCode!: any[];
  controlsList: string[] = [
    'firstname',
    'lastname',
    'selectedDate',
    'selectedSexe',
    'phoneNumber',
    'phoneCode',
    'isWhatsApp',
    'emailGroup.email',
    'emailGroup.confirmEmail',
    'selectedCountry',
    'selectedSituation',
    'selectedRegion',
    'selectedZone',
    'inHandicapSituation',
    'professionnalSituation',
  ];
  isSucces: boolean = false;
  session: boolean = false;
  noSession: boolean = false;
  applied: boolean = false;
  showSpinner: boolean = false;
  cohorteAppel: any = null;

  constructor(
    private formBuilder: FormBuilder,
    private service: BackendApiService,
    private authService: AuthService,
    private spinnerService: SpinnerServiceService,
    private router: Router,
    private activated: ActivatedRoute
  ) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });

    this.soumissionForm = this.formBuilder.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      selectedDate: [null, Validators.required],
      selectedSexe: [null, Validators.required],
      phoneNumber: [null, Validators.required],
      phoneCode: ['221', Validators.required],
      isWhatsApp: [null, Validators.required],
      whatsAppNumber: [null],
      phoneCodeForWhatsApp: ['221'],
      emailGroup: this.formBuilder.group({
        email: [null, [Validators.required, Validators.email]],
        confirmEmail: [null, [Validators.required, Validators.email]],
      }),
      // email: [null, [Validators.required, Validators.email]],
      // confirmEmail: [null, [Validators.required, Validators.email]],
      selectedCountry: [null, Validators.required],
      selectedSituation: [null, Validators.required],
      selectedDiplome: [null, Validators.required],
      selectedRegion: [null, Validators.required],
      selectedZone: [null, Validators.required],
      inHandicapSituation: [null], //no user
      handicapSituations: this.formBuilder.array([]), // FormArray pour gérer plusieurs valeurs
      // professionnalSituation: [null, Validators.required],
      professionnalSituation: this.formBuilder.array([], Validators.required), // FormArray pour gérer plusieurs valeurs
      certificatChoice: [null, Validators.required],
      conditions: [null, Validators.requiredTrue],
      yourProject: [null, Validators.required],
      // handicaps_visuel: [null, Validators.required],
    });

    // Surveille les changements de la situation de handicap
    this.soumissionForm
      .get('inHandicapSituation')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Oui') {
          this.soumissionForm.setControl(
            'handicapSituations',
            this.formBuilder.array([], Validators.required)
          );
        } else {
          this.soumissionForm.setControl(
            'handicapSituations',
            this.formBuilder.array([])
          );
        }
      });
  }

  ngOnInit(): void {
    this.spinnerService.hideSpinner();
    // this.getParamValues();// un formulaire avec plusieurs params possible meme DER
    this.getParamDER_TABA(); // formulaire specifique a DER
    // recup appel a partir de la cohorte de l'url
    this.getCohorteByUrl();

    this.soumissionForm
      .get('isWhatsApp')
      ?.valueChanges.subscribe((isWhatsApp) => {
        if (isWhatsApp === 'NON') {
          this.showWhatsAppNumberFields = true;
          this.soumissionForm
            .get('whatsAppNumber')
            ?.addValidators(Validators.required);
          this.soumissionForm
            .get('phoneCodeForWhatsApp')
            ?.addValidators(Validators.required);
        } else {
          this.showWhatsAppNumberFields = false;
          this.soumissionForm.get('whatsAppNumber')?.clearValidators();
          this.soumissionForm.get('phoneCodeForWhatsApp')?.clearValidators();
        }
      });

    //handicap
    this.showHandicapChoices();
    //application en cours
    // this.currentApplicationOffTrack();

    //countries

    this.authService.getCountries().subscribe((data) => {
      this.countries = data.sort((c, d) => (c.name < d.name ? -1 : 1));
      // console.log('country :', this.countries);
    });
    this.authService.getCountries().subscribe((data) => {
      //console.log(data);
      this.phoneCode = data.sort((c, d) => c.phoneCode - d.phoneCode);
      //console.log(this.phoneCode);
      this.phoneCodeWhatsapp = this.phoneCode;
    });

    //region
    this.regions = LOCALISATIONS.Regions;
    //diplomes
    this.diplomes = ProfilDetailsHorsParcours.DiplomeForApplications;
    //zones
    this.zones = LOCALISATIONS.Zones;

    this.soumissionForm
      .get('selectedCountry')
      ?.valueChanges.subscribe((values) => {
        if (values === 'Autre') {
          this.soumissionForm.addControl(
            'otherCountry',
            this.formBuilder.control(null, Validators.required)
          );
          this.controlsList.push('otherCountry');
        } else {
          this.soumissionForm.removeControl('otherCountry');
          this.controlsList = this.controlsList.filter(
            (e) => e !== 'otherCountry'
          );
        }
      });
    this.watchHandicapSelection();
  }

  //definir lees parames
  getParamValues() {
    this.activated.paramMap.subscribe((params) => {
      let value = params.get('partener');

      const agents = Array.from({ length: 21 }, (_, i) => `FABAGENT${i + 1}`);
      agents.push('DER');
      agents.push('FODE');

      if (!value) {
        this.paramValue = 'FODE';
        return;
      }

      this.paramValue = agents.includes(value) ? value : 'invalidParam';
      // console.log(`test agents : ${agents}`);
      // console.log(`'parmas value : ${this.paramValue}`);
    });
  }

  //ceci est specifique pour DER (c 1 cas ou le formulaire é valable uniquement pour DER) UN IMPREVU
  getParamDER_TABA() {
    this.activated.paramMap.subscribe((param) => {
      let value = param.get('partener') || '';

      const setDER_TABA = new Set([
        'DER',
        'TABA',
        'ANPEJ',
        'RECRUTEL',
        'ADEPME',
        'DE',
      ]);
      const agentDER_TABA = Array.from(setDER_TABA);
      // console.log('DERRRR :', agentDER_TABA);

      this.paramValueDER_TABA = agentDER_TABA.includes(value) ? value : '';
      // : 'invalidParam';
      // console.log('paramValueDER_TABA :', this.paramValueDER_TABA);
    });
  }

  // recup appel a partir de la cohorte de l'url
  getCohorteByUrl() {
    this.activated.paramMap.subscribe((params) => {
      this.cohorteAppel = params.get('cohorte') || '';

      // console.log("cohorte et param before: ",this.cohorteAppel , this.paramValue)

      // console.log("cohorte et param after: ",this.cohorteAppel , this.paramValue)

      this.currentApplicationOffTrack(this.cohorteAppel);
    });
  }

  // Gestion des cases à cocher
  onCheckboxChange(event: any) {
    const formArray: FormArray = this.soumissionForm.get(
      'professionnalSituation'
    ) as FormArray;

    if (event.target.checked) {
      formArray.push(new FormControl(event.target.value));
    } else {
      let index = formArray.controls.findIndex(
        (x) => x.value === event.target.value
      );
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
  }

  // Fonction pour gérer les changements des checkboxes
  onHandicapCheckboxChange(event: any) {
    const handicapSituationsArray = this.soumissionForm.get(
      'handicapSituations'
    ) as FormArray;

    if (event.target.checked) {
      // Ajouter uniquement si ce n'est pas déjà présent
      if (!handicapSituationsArray.value.includes(event.target.value)) {
        handicapSituationsArray.push(new FormControl(event.target.value));
      }
    } else {
      // Supprimer la valeur si décochée
      let index = handicapSituationsArray.value.indexOf(event.target.value);
      if (index !== -1) {
        handicapSituationsArray.removeAt(index);
      }
    }

    // Déclencher la validation manuellement
    handicapSituationsArray.markAsTouched();
    handicapSituationsArray.updateValueAndValidity();
  }

  // Vérification si un champ est invalide
  //  isFieldInvalid(controlName: string): boolean {
  //   const control = this.soumissionForm.get(controlName);
  //   return control ? control.invalid && control.touched : false;
  // }

  //application en cours
  currentApplicationOffTrack(cohorte: string) {
    this.service
      .getCurrentApplicationOffTrack(cohorte)
      .subscribe((application) => {
        // console.log('Application : ', application);
        if (application.status == 200 && application.object?.length) {
          this.session = true;
          this.noSession = false;
          this.appelCloseDate = application.object[0].closeDate;
          this.appelName = application.object[0].applicationName;
          this.cohorte = application.object[0].cohorte;
          // console.log('cohorte :', this.cohorte);

          if (application.object[0].independentCertificateList?.length) {
            this.certificatDynamicOption =
              application.object[0].independentCertificateList.map(
                (certif: any) => ({
                  id: certif.externalId,
                  name: certif.name,
                })
              );
            // console.log('certificatName : ', this.certificatDynamicOption);
            //selectionnei du premier certificat par défaut
            if (this.cohorteAppel === 'MAE2509-FODE') {
              this.soumissionForm
                .get('certificatChoice')
                ?.setValue(this.certificatDynamicOption[0].id);
            }
          }
        } else {
          this.session = false;
          this.noSession = true;
        }
      });
  }

  showZoneOfResidenceDiv(): boolean {
    return this.soumissionForm.get('selectedRegion')?.value !== 'Dakar';
  }

  // check if the applicant is alredy apply with the same cohorte
  checkApply(email: string, cohorte: string): Observable<boolean> {
    //console.log('EMAIL ET COHORTE : ', email, cohorte);
    return this.service.applyCheckOffTrack(email, cohorte).pipe(
      tap((response) => {
        if (response.applied) {
          this.session = false;
          this.applied = true;
          //console.log('Déjà dans la cohorte:', response);
          setTimeout(() => {
            this.applied = false;
            window.location.reload();
          }, 2500);
        } else {
          this.applied = false;
        }
      }),
      map((response) => !response.applied) // Retourne tru si le candidat N'A PAS postulei, sinon fls
    );
  }

  onSubmitForm() {
    // if (
    //   this.paramValueDER_TABA === 'invalidParam' ||
    //   this.paramValueDER_TABA === ''
    // ) {
    //   this.invalid = true;
    //   setTimeout(() => {
    //     this.invalid = false;
    //     // Redirige vers l'URL sans paramètre (FODE)
    //     this.router.navigateByUrl('/url_invalide_veuillez_taper_le_bon_url!');
    //   }, 5500);
    //   return;
    // }
    // console.log('params sub :', this.paramValueDER_TABA);
    if (this.soumissionForm.invalid) {
      this.showPopup = true;
      this.soumissionForm.markAllAsTouched();
      return;
    }
    const formValue = this.soumissionForm.value;
    const selectedStatuts = formValue.professionnalSituation; // Récupération des statuts sélectionnés
    const selectedHandicaps = formValue.handicapSituations || [];

    // check if the applicant is alredy apply with the same cohorte
    this.checkApply(formValue['emailGroup']?.email, this.cohorte).subscribe(
      (canApply) => {
        if (!canApply) {
          // console.log('Le candidat a déjà postulé. Arrêt du processus.');
          return;
        }
        const candidatureRequest = new candidatureRequestHorsParcours(
          new Date(), // submissionDate
          formValue['conditions'], // conditionsAccepted
          formValue['firstname'],
          formValue['lastname'],
          new Date(formValue['selectedDate']),
          this.Age(formValue['selectedDate']),
          formValue['selectedSexe'],
          formValue['phoneCode']
            ? formValue['phoneCode'] + formValue['phoneNumber']
            : '',
          formValue['isWhatsApp'] === 'OUI',
          formValue['isWhatsApp'] === 'OUI'
            ? formValue['phoneCode'] + formValue['phoneNumber']
            : formValue['phoneCodeForWhatsApp'] + formValue['whatsAppNumber'],
          formValue['emailGroup']?.email ?? '',
          formValue['emailGroup']?.confirmEmail ?? '',
          formValue['selectedCountry'],
          formValue['selectedCountry'] === 'Autre'
            ? formValue['otherCountry']
            : '',
          // formValue['professionnalSituation'] ?? [],
          selectedStatuts, // professionnalSituation
          formValue['selectedDiplome'],
          formValue['selectedRegion'],
          formValue['inHandicapSituation'] === 'Oui', //no user
          selectedHandicaps,
          formValue['certificatChoice'],
          formValue['yourProject'],
          formValue['phoneCode'],
          this.appelCloseDate,
          this.cohorte,
          formValue['selectedSituation'],
          false, // isSubmitted
          this.paramValueDER_TABA,
          formValue['selectedZone']
        );

        // console.log(
        //   'Valeur de selectedSituation: 2',
        //   formValue['selectedSituation']
        // );

        //save candidature offTrack
        this.applyOffTrack(candidatureRequest);
        // console.log('candidatureRequest:', candidatureRequest);
      }
    );
  }

  applyOffTrack(candidatureRequest: candidatureRequestHorsParcours) {
    this.spinnerService.showSpinner();
    this.service
      .applyOffTrack(candidatureRequest)
      .pipe(
        tap((response) => {
          if (response != null) {
            this.spinnerService.hideSpinner();
            this.isSucces = true;
            sessionStorage.setItem('canSuccess', '1');
            setTimeout(() => {
              this.soumissionForm.reset();
              this.isSucces = false;
              this.router.navigateByUrl(
                `horsigui/candidature/MAE2509-FODE/reussie`
                // `horsigui/candidature/MAE2509-FODE/reussie/${this.paramValueDER_TABA}`
              );
            }, 1000);
          }
        })
      )
      .subscribe();
  }

  Age(dateOfBirth: string): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }
  addHandicapsArray(): void {
    this.soumissionForm.addControl(
      'handicaps_moteur',
      this.formBuilder.control(false) // Ajout de la validation requise
    );
    this.soumissionForm.addControl(
      'handicaps_visuel',
      this.formBuilder.control(false)
    );
    this.soumissionForm.addControl(
      'handicaps_auditif',
      this.formBuilder.control(false)
    );
    this.soumissionForm.addControl(
      'handicaps_autre',
      this.formBuilder.control(false)
    );
  }

  showHandicapChoices(): void {
    this.soumissionForm
      .get('inHandicapSituation')
      ?.valueChanges.subscribe((inHandicapSituation) => {
        if (inHandicapSituation === 'Oui') {
          this.showHandicapChoiceRadio = true;

          this.addHandicapsArray();
          this.handicapCheck();
        } else {
          this.showHandicapChoiceRadio = false;
          this.removeHandicapsArray();
        }
      });
  }
  removeHandicapsArray(): void {
    this.soumissionForm.removeControl('handicaps_visuel');
    this.soumissionForm.removeControl('handicaps_moteur');
    this.soumissionForm.removeControl('handicaps_auditif');
    this.soumissionForm.removeControl('handicaps_autre');
  }
  handicapCheck(): void {
    this.soumissionForm
      .get('handicaps_moteur')
      ?.valueChanges.subscribe((moteur) => {
        //console.log('moteur: ', moteur);
        if (moteur === true) {
          //console.log('moteur: ', moteur);
          this.chooseAHandicapMoteur = false;
        } else {
          this.chooseAHandicapMoteur = true;
        }
      });
    this.soumissionForm
      .get('handicaps_visuel')
      ?.valueChanges.subscribe((visuel) => {
        if (visuel === true) {
          this.chooseAHandicapVisuel = false;
        } else {
          this.chooseAHandicapVisuel = true;
        }
      });
    this.soumissionForm
      .get('handicaps_auditif')
      ?.valueChanges.subscribe((auditif) => {
        if (auditif === true) {
          this.chooseAHandicapAuditif = false;
        } else {
          this.chooseAHandicapAuditif = true;
        }
      });
    this.soumissionForm
      .get('handicaps_autre')
      ?.valueChanges.subscribe((autre) => {
        if (autre === true) {
          this.chooseAHandicapAutre = false;
        } else {
          this.chooseAHandicapAutre = true;
        }
      });
  }

  watchHandicapSelection() {
    this.soumissionForm
      .get('inHandicapSituation')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Oui') {
          this.showHandicapChoiceRadio = true;
        } else {
          this.showHandicapChoiceRadio = false;
          this.chooseAHandicapMoteur = false;
          this.chooseAHandicapAuditif = false;
          this.chooseAHandicapVisuel = false;
          this.chooseAHandicapAutre = false;
        }
      });
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);
    return control && control.invalid && control.touched;
  }

  isFieldInvalidForMails(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);
    return control && control.errors?.['required'] && control.touched;
  }

  isMailFieldInvalid(control: string): boolean | null {
    return (
      this.soumissionForm.get(control)?.errors?.['email'] &&
      this.soumissionForm.get(control)?.touched
    );
  }
}
